export interface IName {
  name: string;
}

class Sort {
  static alphabetically(a: string, b: string): number {
    return a.localeCompare(b);
  }

  static byName(a: IName, b: IName): number {
    return Sort.alphabetically(a.name, b.name);
  }

  static byField(field: string) {
    return function sortByField(a: any, b: any): number {
      return a[field] - b[field];
    };
  }
}

export default Sort;
